<div class="container bluebarlight fblock mat-elevation-z8">
    <div class="row orangebar justify-content-center mb-3">
        <div class="col-12 text-center">
            <h1 class=" coolfont">Services We Offer</h1>
        </div>
    </div>
    <div class="row justify-content-center text-center">
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 mr-3 mb-3 ml-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Home Broadband Services</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>Secured wired and wireless Broadband Internet solution with affordable prepaid plans with no hidden charges. Our ultimate success preposition is our same day connection and activation policy for home broadband users.</p></div>
            </div>
        </div>
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Corporate Broadband Services</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>Custom internet plans for corporate users as per their requirement.</p></div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center text-center">
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Wireless Connectivity Solutions</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>Long distance point to point wireless connectivity solution up to 50 kilometers for corporates and companies who wish to share their internet or local area connection to transfer data securely from their central office to other office for factories at remote locations where other connectivity solutions are unavailable.</p></div>
            </div>
        </div>
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Wifi Hotspots</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>Solutions for hotels, offices & educational institutions who wish to provide users internet over wifi with data download & speed limit for every individual user. This helps in optimum utilisation of available internet bandwidth to users who requires the most and who requires the least.</p></div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center text-center">
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Bandwidth Shaping</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>Bandwidth shaping solutions for colleges, offices and other companies to effectively utilise their internet speed by allocations desired speed to each employee over wireless or wired network.</p></div>
            </div>
        </div>
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Internet Lease Line</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>Internet lease line is a connectivity solution for corporates and companies who require stable , redundant and uninterrupted internet in 1:1 ratio. Our lease line solutions are available in competitive tariff plans with less than one week installation and activation time.</p></div>
            </div>
        </div>
    </div>
    <div class="row justify-content-center text-center">
        <div class="col-lg-5 col-xs-11 curved mat-elevation-z8 ml-3 mb-3 mr-3 orangebar coolfont">
            <div class="row mat-elevation-z8 bluebar">
                <div class="col-12 coolfont"><h4>Advertisements Over WiFi</h4>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12"><p>This can be used for branding by broadcasting your company name over wifiupto 2-5 kilometers. As soon as the user will connect his smart phone or laptop to your secured open wifi network, he will be automatically redirected to webpage with your company advertisement on the page. This service is helpful for hotels, coaching institutes and other educational institutions.</p></div>
            </div>
        </div>
    </div>
</div>


